export const homework = {
    "homework_bank_title": "作业库",
    "homework_bank_create": "创建作业库",
    "homework_bank_edit": "编辑作业库",
    "homework_bank_delete": "删除作业库",
    "homework_bank_delete_confirm": "确定要删除这个作业库吗？",
    "homework_bank_name": "名称",
    "homework_bank_description": "描述",
    "homework_bank_type": "类型",
    "homework_bank_type_public": "公开",
    "homework_bank_type_class": "班级",
    "homework_bank_type_teacher": "教师",
    "homework_bank_type_auth_public": "授权公开",
    "homework_bank_subject": "科目",
    "homework_bank_class": "班级",
    "homework_bank_create_by": "创建者",
    "homework_bank_created_at": "创建时间",
    "homework_bank_updated_at": "更新时间",
    "homework_bank_actions": "操作",
    "homework_bank_edit_btn": "编辑",
    "homework_bank_delete_btn": "删除",
    "homework_bank_view_cards": "卡片视图",
    "homework_bank_view_list": "列表视图",
    "homework_bank_filter_type": "筛选类型",
    "homework_bank_filter_subject": "筛选科目",
    "homework_bank_filter_class": "筛选班级",
    "homework_bank_empty": "暂无作业库数据",
    "homework_bank_loading": "加载中...",
    "homework_bank_create_first": "创建第一个作业库",
    "homework_bank_name_placeholder": "请输入作业库名称",
    "homework_bank_description_placeholder": "请输入作业库描述（可选）",
    "homework_bank_name_required": "请输入作业库名称",
    "homework_bank_name_max": "作业库名称不能超过100个字符",
    "homework_bank_description_max": "作业库描述不能超过500个字符",
    "homework_bank_type_required": "请选择作业库类型",
    "homework_bank_create_success": "创建成功",
    "homework_bank_update_success": "更新成功",
    "homework_bank_delete_success": "删除成功",
    "homework_bank_create_failed": "创建失败",
    "homework_bank_update_failed": "更新失败",
    "homework_bank_delete_failed": "删除失败",
    "homework_bank_all_types": "全部类型",
    "homework_bank_all_subjects": "全部科目",
    "homework_bank_all_classes": "全部班级",
    "homework_bank_tab_teacher": "我的题库",
    "homework_bank_tab_public": "公共题库",
    "homework_bank_tab_auth": "学术题库",
    "homework_bank_tab_instruction": "说明",
    "homework_bank_instruction_public_title": "公共题库",
    "homework_bank_instruction_public_desc": "由学术老师维护的公共作业库，供其他老师使用。",

    "homework_bank_instruction_auth_title": "学术题库",
    "homework_bank_instruction_auth_desc": "仅你自己可见的私有仓库，可授权给特定班级；被授权班级的老师可查看并下发此仓库中的作业。",

    "homework_bank_instruction_teacher_title": "我的题库",
    "homework_bank_instruction_teacher_desc": "用于存放自己的题库，在授课班级中可直接使用。",

    "homework_bank_search_placeholder": "搜索作业库名称或描述",
    "homework_bank_cancel": "取消",
    "homework_bank_view_btn": "查看",
    "homework_temp_title": "作业模板详情",
    "homework_temp_back": "返回作业库",
    "homework_temp_upload_file": "解析文件",
    "homework_temp_upload_question": "上传题目文件（必填）",
    "homework_temp_upload_answer": "上传答案文件（可选）",
    "homework_temp_create_question": "创建题目",
    "homework_temp_edit_mode": "编辑模式",
    "homework_temp_view_mode": "查看模式",
    "homework_temp_save": "保存",
    "homework_temp_cancel": "取消",
    "homework_temp_delete": "删除",
    "homework_temp_add_question": "添加题目",
    "homework_temp_add_paragraph": "添加段落",
    "homework_temp_question_type": "题目类型",
    "homework_temp_question_type_select": "单选题",
    "homework_temp_question_type_mutil_select": "多选题",
    "homework_temp_question_type_true_false": "判断题",
    "homework_temp_question_type_empty": "段落",
    "homework_temp_question_type_simple_text": "简答题",
    "homework_temp_question_type_fill_blank": "填空题",
    "homework_temp_question_type_essay": "作文题",
    "homework_temp_question_type_drag_select": "拖选题",
    "homework_temp_question_type_match_line": "连线题",
    "homework_temp_question_type_pointer_select": "指针位置选题",
    "homework_temp_question_type_sort_order": "排序题",
    "homework_temp_fill_blank_stem": "子题干",
    "homework_temp_fill_blank_ref_answer": "参考答案（可选，供老师对照）",
    "homework_temp_add_fill_blank": "添加填空",
    "homework_temp_match_pair_source": "左侧/源",
    "homework_temp_match_pair_target": "右侧/目标",
    "homework_temp_add_match_pair": "添加配对项",
    "homework_temp_set_correct_pairs": "设置正确配对",
    "homework_temp_match_pair_hint": "每拖中/连对一个得 满分/正确配对数 的分",
    "homework_temp_pointer_text": "原文",
    "homework_temp_pointer_positions": "可选位置",
    "homework_temp_pointer_edit_positions": "编辑可选位置",
    "homework_temp_pointer_edit_answers": "编辑正确答案",
    "homework_temp_pointer_select_hint": "在下方文字上点击设置；正确答案须为可选位置的子集",
    "homework_temp_pointer_teacher_hint": "点击字符添加指针；点击下方圆点标记正确答案（实心为已选）",
    "homework_temp_pointer_click_toggle_position": "点击切换可选位置（下标 {{index}}）",
    "homework_temp_pointer_mark_correct": "标为正确答案",
    "homework_temp_pointer_positions_summary": "可选下标：[{{positions}}]；正确答案下标：[{{answers}}]",
    "homework_temp_match_setup_title": "设置选项与正确配对",
    "homework_temp_match_setup_desc": "请先在下方分别填写左侧（源）与右侧（目标）的全部选项文字，再在上方面板中拖选或连线。",
    "homework_temp_match_column_source": "左侧（源）",
    "homework_temp_match_column_target": "右侧（目标）",
    "homework_temp_match_add_source": "添加左侧项",
    "homework_temp_match_add_target": "添加右侧项",
    "homework_temp_match_fill_options_first": "请先填写至少一项左侧与一项右侧选项文字",
    "homework_temp_match_empty_slot": "（未填写）",
    "homework_temp_match_line_connect_hint": "连线模式：先点击左侧项，再点击右侧项建立连线；再次点击同一对可取消。支持多对多。",
    "homework_temp_match_drag_connect_hint": "拖选模式：从左侧项拖拽到右侧项建立配对；支持同一左侧连多个右侧。",
    "homework_temp_match_many_to_many_hint": "可设置多条正确配对（多对多）；学生端连线题每个源最多连一条。",
    "homework_temp_match_line_setup_title": "连线题设置",
    "homework_temp_match_line_setup_desc": "左右两侧可添加不同数量的选项；填好后在下方点击或拖拽连线，每条线颜色不同。",
    "homework_temp_match_line_interact_hint": "先点击或拖拽左侧项，再点击右侧项完成连线；再次操作可取消。",
    "homework_temp_drag_select_setup_title": "拖选题设置",
    "homework_temp_drag_select_setup_desc": "左侧为待选答案池，右侧为各空位（子题干 + 正确答案）。学生从左侧拖入选项填入各空。",
    "homework_temp_drag_select_pool": "待选答案池",
    "homework_temp_drag_select_pool_hint": "学生从此处拖入选项",
    "homework_temp_drag_select_blanks": "各空位",
    "homework_temp_drag_select_blanks_hint": "填写子题干，并选择该空正确答案",
    "homework_temp_drag_select_pick_answer": "选择正确答案",
    "homework_temp_question_drag_select_required": "题目 {{index}} 需配置选项池、至少一个空位及每空正确答案",
    "student_homework_drag_select_pool_hint": "将词语拖到右侧空格中",
    "student_homework_drag_select_drop_here": "拖放答案到此处",
    "student_homework_match_line_hint": "点击或拖拽左侧项连到右侧；每个左侧项最多连一条线",
    "homework_temp_question_fill_blank_required": "题目 {{index}} 至少需要一个填空项",
    "homework_temp_question_match_pair_required": "题目 {{index}} 至少需要一个配对项并设置正确答案",
    "homework_temp_question_pointer_required": "题目 {{index}} 需设置原文、可选位置与正确答案",
    "homework_temp_essay_hint": "作文题需老师批改，学生提交后由老师评分",
    "student_homework_fill_blank_placeholder": "请填写",
    "student_homework_essay_placeholder": "请输入作文内容",
    "student_homework_match_select_target": "选择对应项",
    "student_homework_pointer_hint": "点击下方圆点选择位置（至少选一个）",
    "student_homework_pointer_label": "可多选位置",
    "homework_temp_question_mutil_select_hint": "多选题，至少选择2个答案",
    "homework_temp_question_mutil_select_label": "可多选",
    "homework_temp_question_mutil_select_answer_required": "题目 {{index}} 是多选题，至少需要选择2个答案",
    "homework_temp_question_content": "题目内容",
    "homework_temp_question_desc": "注释",
    "homework_temp_question_options": "选项",
    "homework_temp_question_answer": "答案",
    "homework_temp_question_index": "题号",
    "homework_temp_correct_answer": "正确答案",
    "homework_temp_need_teacher_read": "需老师批改",
    "homework_temp_question_score": "题目分数",
    "homework_temp_part_default_score": "本部分默认分数",
    "homework_temp_manner_read": "人工批阅",
    "homework_temp_exam_mode": "考试模式",
    "homework_temp_exam_duration": "考试时长（分钟）",
    "homework_temp_exam_duration_hint": "最短 5 分钟，默认 90 分钟",
    "homework_temp_exam_tag": "考试",
    "homework_assign_exam_alert": "所选模板为考试作业，请确认考试时长",
    "homework_assign_exam_duration": "考试时长（分钟）",
    "homework_temp_simple_text_answer_placeholder": "输入参考答案（多行表示多个可接受答案，可选，供老师对照）",
    "homework_temp_simple_text_answer_hint": "简答题由老师批改打分；参考答案仅作对照，不自动判分",
    "homework_temp_part_name": "部分名称",
    "homework_temp_part_desc": "部分描述",
    "homework_temp_upload_image": "上传图片",
    "homework_temp_image_limit": "图片大小不能超过2M，最多30张",
    "homework_temp_click_image_to_insert": "请点击图片，插入到编辑器光标位置",
    "homework_temp_loading_detail": "加载详情中...",
    "homework_temp_cache_restored": "已从缓存恢复数据",
    "homework_temp_cache_restore_failed": "缓存恢复失败",
    "homework_temp_name": "模板名称",
    "homework_temp_name_duplicate_hint": "该作业库中已有同名模板",
    "homework_temp_name_duplicate_save": "请修改模板名称后再创建",
    "homework_temp_description": "模板描述",
    "homework_temp_name_required": "请输入模板名称",
    "homework_temp_save_success": "保存成功",
    "homework_temp_save_failed": "保存失败",
    "homework_temp_delete_confirm": "确定要删除这个模板吗？",
    "homework_temp_delete_success": "删除成功",
    "homework_temp_delete_failed": "删除失败",
    "homework_temp_migrate": "迁移",
    "homework_temp_migrate_title": "迁移作业模板",
    "homework_temp_migrate_target_bank": "目标作业库",
    "homework_temp_migrate_target_bank_placeholder": "请选择目标作业库",
    "homework_temp_migrate_confirm": "确定将「{{name}}」迁移到所选作业库吗？",
    "homework_temp_migrate_success": "迁移成功",
    "homework_temp_migrate_failed": "迁移失败",
    "homework_temp_migrate_same_type_hint": "只能在同类型作业库之间迁移（例如公共库只能迁到公共库）",
    "homework_temp_migrate_no_target": "没有其他可迁移的作业库",
    "homework_temp_migrate_name_conflict": "目标作业库中已存在同名模板，请先修改模板名称",
    "homework_temp_upload_success": "文件上传成功",
    "homework_temp_upload_failed": "文件上传失败",
    "homework_temp_question_click_load": "点击题目加载详情",
    "homework_temp_image_count": "图片数量",
    "homework_temp_max_images": "最多30张图片",
    "homework_temp_image_too_large": "图片大小不能超过2M",
    "homework_temp_load_detail_failed_no_data": "加载模板详情失败：未返回数据",
    "homework_temp_load_detail_failed": "加载模板详情失败",
    "homework_temp_parse_file_failed": "解析文件失败：未返回有效数据",
    "homework_temp_delete_part_confirm_title": "确认删除",
    "homework_temp_delete_part_confirm_content": "确定要删除这个部分吗？删除后该部分下的所有题目也会被删除。",
    "homework_temp_question_content_empty": "题目 {{index}} 的内容不能为空",
    "homework_temp_question_select_answer_required": "题目 {{index}} 必须勾选正确答案",
    "homework_temp_question_true_false_answer_required": "题目 {{index}} 必须选择正确答案（True/False）",
    "homework_temp_image_preview": "图片预览",
    "homework_temp_validation_failed": "验证失败",
    "homework_temp_confirm": "确定",
    "homework_temp_cancel_btn": "取消",
    "homework_temp_create": "创建",
    "homework_temp_add_part": "新增Part",
    "homework_temp_delete_part": "删除部分",
    "homework_temp_insert_image": "插入图片",
    "homework_temp_add_option": "添加选项",
    "homework_temp_preview": "预览",
    "homework_temp_image": "图片",
    "homework_temp_option": "选项",
    "homework_temp_sort_order_setup_title": "排序题设置",
    "homework_temp_sort_order_setup_desc": "添加待排序项，并拖拽排列正确顺序。全部排对才得满分。",
    "homework_temp_sort_order_correct_order": "正确顺序",
    "homework_temp_sort_order_drag_hint": "拖拽调整从上到下的正确顺序",
    "homework_temp_sort_order_add_item": "添加排序项",
    "homework_temp_sort_order_item_placeholder": "排序项内容",
    "homework_temp_sort_order_incomplete": "题目配置不完整",
    "homework_temp_question_sort_order_required": "题目 {{index}} 至少需要 2 个排序项并设置正确顺序",
    "student_homework_sort_order_hint": "请拖拽调整顺序（题目已随机打乱）",
    "homework_temp_question_audio": "题干音频",
    "homework_temp_audio_hint": "支持 mp3、mp4（音频）等格式，最大 2MB，可裁切预览",
    "homework_temp_audio_upload": "上传音频",
    "homework_temp_audio_remove": "移除音频",
    "homework_temp_audio_crop_title": "音频裁切",
    "homework_temp_audio_crop_desc": "可拖动滑块选择起止时间，或使用完整音频",
    "homework_temp_audio_crop_range": "裁切区间",
    "homework_temp_audio_use_full": "使用完整音频",
    "homework_temp_audio_crop_confirm": "确认裁切",
    "homework_temp_audio_too_large": "音频大小不能超过 2MB",
    "homework_temp_audio_format_invalid": "仅支持 mp3、mp4（音频）、m4a、aac、webm、ogg、wav",
    "homework_temp_audio_uploaded": "音频已保存",
    "homework_temp_audio_upload_failed": "音频上传失败",
    "homework_temp_audio_load_failed": "无法加载音频",
    "homework_temp_audio_crop_failed": "音频裁切失败",
    "homework_temp_audio_crop_too_short": "裁切区间过短",
    "homework_temp_audio_crop_preview_duration": "裁切后时长 {{cropped}}s（原音频 {{total}}s）",
    "homework_temp_question_audio_required": "题目 {{index}} 已启用音频但未上传音频数据",
    "homework_temp_question_type_writing_task": "写作任务题",
    "homework_temp_writing_task_hint": "写作任务题支持文件上传或键盘输入，需老师批改",
    "writing_task_mode_file": "上传文件",
    "writing_task_mode_text": "键盘输入",
    "writing_task_switch_mode_title": "切换提交方式",
    "writing_task_switch_mode_content": "切换将清空当前内容，是否继续？",
    "writing_task_upload_hint": "拖曳或点击上传文件",
    "writing_task_upload_count": "已上传 {{count}} / {{max}} 个文件",
    "writing_task_selected_count": "已选择 {{count}} / {{max}} 个文件",
    "writing_task_upload_on_submit_hint": "文件将在暂存或提交时上传",
    "writing_task_pending_tag": "待上传",
    "writing_task_uploaded_tag": "已上传",
    "writing_task_upload_progress": "正在上传附件",
    "writing_task_upload_progress_hint": "请稍候，上传完成前请勿关闭页面",
    "writing_task_no_files": "暂无提交文件",
    "writing_task_file_count": "共 {{count}} 个文件",
    "writing_task_view_file": "查看",
    "writing_task_open_file_error": "无法打开文件，请稍后重试",
    "writing_task_download_file": "下载",
    "writing_task_local_office_preview_hint": "Word 文档需提交后在预览中查看",
    "writing_task_preview": "预览",
    "writing_task_text_placeholder": "请在此输入作文内容",
    "writing_task_max_files": "最多上传 {{max}} 个文件",
    "writing_task_upload_error": "文件上传失败",
    "writing_task_upload_network_error": "文件上传失败：网络连接中断，请检查网络后重试或联系管理员确认服务器已更新",
    "writing_task_delete_error": "删除文件失败",
    "writing_task_student_files": "学生提交",
    "writing_task_feedback_files": "批改文件",
    "writing_task_feedback_optional_hint": "可仅填写评语，批改文件为可选项",
    "writing_task_upload_feedback_hint": "上传批改后的文件（可选）",
    "writing_task_supplementary_files": "补充材料",
    "writing_task_upload_supplementary_hint": "上传补充材料（可选）",
    "writing_task_revision_hint": "在下方编辑区修改作文，提交后将显示修订标识",
    "writing_task_original": "原文",
    "writing_task_revised": "修订稿",
    "writing_task_teacher_revision": "老师修订",
    "writing_task_allowed_types": "支持 JPG、PNG、PDF、Word、WPS 文字，单文件不超过 20MB",
    "writing_task_file_type_invalid": "不支持该文件类型，请上传 JPG、PNG、PDF、Word 或 WPS 文字",
    "writing_task_file_too_large": "单文件不能超过 {{maxMb}}MB",

    "writing_rubric_content": "内容",
    "writing_rubric_organization": "结构",
    "writing_rubric_language": "语言",
    "writing_rubric_grammar": "语法",
    "writing_task_grade_editor_hint": "可为每段添加备注而无需全文重写；如需修改词句，请在修订稿中编辑。",
    "writing_task_grade_tab_edit": "批改",
    "writing_task_grade_tab_preview": "预览",
    "writing_task_paragraph_comments": "段落备注",
    "writing_task_paragraph_label": "第 {{index}} 段",
    "writing_task_paragraph_comment_label": "老师备注",
    "writing_task_paragraph_comment_placeholder": "在此填写对该段的修改建议…",
    "writing_task_paragraph_comments_preview": "段落备注预览",
    "writing_task_rubric_title": "分项评价",
    "writing_task_rubric_max": "满分 {{score}} 分",
    "writing_task_rubric_comment_placeholder": "该维度评语（可选）",
    "writing_task_revision_preview": "修订预览",
    "writing_task_no_revision_yet": "暂无文字删改（可仅添加段落备注）",
    "writing_task_live_preview": "实时预览",
    "writing_task_rubric_result_title": "分项得分",
    "writing_task_rubric_column_dimension": "维度",
    "writing_task_rubric_column_score": "得分",
    "writing_task_rubric_column_comment": "评语",

    "create_homework_mode_bank": "从题库选择",
    "create_homework_mode_quick_writing": "快捷作文",
    "quick_writing_hint": "将自动在教师个人题库创建「说明段落 + 一道写作题」模板并下发作业。学生可选择上传文件或键盘输入作答。",
    "quick_writing_homework_name": "作业名称",
    "quick_writing_homework_name_placeholder": "例如：Week 3 Writing",
    "quick_writing_instruction": "说明段落（可选）",
    "quick_writing_instruction_placeholder": "写作要求、字数提示等，将显示在题目上方",
    "quick_writing_prompt": "作文题干",
    "quick_writing_prompt_placeholder": "例如：Write about your favorite pet.",
    "quick_writing_total_score": "满分",
    "quick_writing_assign_btn": "创建并下发",
    "quick_writing_name_required": "请填写作业名称",
    "quick_writing_prompt_required": "请填写作文题干",
    "quick_writing_assign_error": "快捷作文下发失败，请重试",

    "homework_bank_tab_temps": "试卷列表",
    "homework_bank_tab_grade_config": "等级设置",
    "homework_bank_tab_stats": "分数统计",
    "grade_band_description": "等级说明",
    "grade_band_description_placeholder": "向学生和老师说明本作业库的等级划分标准",
    "grade_band_mode": "分段模式",
    "grade_band_mode_percentage": "百分比分段",
    "grade_band_mode_absolute": "绝对分数分段",
    "grade_band_name": "等级名称",
    "grade_band_name_required": "请输入等级名称",
    "grade_band_threshold_required": "请输入阈值",
    "grade_band_band_desc": "分段评语（可选）",
    "grade_band_band_comment_placeholder": "学生落入该分段时看到的评语，未填写则学生端不显示",
    "grade_band_add_band": "添加等级",
    "grade_band_preview": "分段预览",
    "grade_band_save": "保存配置",
    "grade_band_reset_default": "恢复默认",
    "grade_band_save_success": "等级配置已保存",
    "grade_band_save_failed": "保存失败",
    "grade_band_points": "分",
    "grade_band_absolute_invalid": "作业库内试卷满分不一致，无法使用绝对分数分段",
    "grade_band_max_score_hint": "当前试卷满分为 {{score}} 分，绝对分段末级阈值应等于满分",
    "grade_band_temp_override_title": "等级配置（试卷独立）",
    "grade_band_use_custom": "使用自定义等级配置",
    "grade_band_paper_max_score": "试卷满分",
    "grade_band_stats_empty": "暂无完成记录",
    "grade_band_stats_total": "完成人次",
    "grade_band_stats_distribution": "等级分布",
    "grade_band_stats_by_temp": "按试卷统计",
    "grade_band_stats_count": "完成数",
    "grade_band_stats_avg_score": "平均分",
    "grade_band_result_title": "等级分段",
};
